
import { motion } from "framer-motion";

export const RecipeTransformationHeader = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: -10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.2, duration: 0.5 }}
    >
      <h2 className="text-3xl sm:text-4xl font-bold text-center bg-gradient-to-r from-primary to-primary-foreground/90 bg-clip-text text-transparent">
        Transform Your Recipe
      </h2>
      <p className="text-center text-gray-600 text-sm sm:text-base px-4 mt-2">
        Paste a recipe URL below and we'll transform it into an easy-to-follow version just for you!
      </p>
    </motion.div>
  );
};
